import { render, staticRenderFns } from "./EditAppLimitModal.vue?vue&type=template&id=1dea5438&"
import script from "./EditAppLimitModal.vue?vue&type=script&lang=js&"
export * from "./EditAppLimitModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports